import { getAllExpressions, getExpressionData } from "api/expression";
import { getAllTags, getTagData } from "api/tags";
import tabBodyConfig from "./dashboard/tabBodyConfig";
import { WidgetsProvider } from "hooks/dynamicWidgets/useWidgets";
import { WidgetsDataProvider } from "hooks/dynamicWidgets/useWidgetsData";
import { TabsProvider } from "hooks/dynamicWidgets/useTabs";

const widgetLayerConfig = {
  getTagData,
  getAllTags,
  getExpressionData,
  getAllExpressions
};

const addWidgetModalConfig = {
  getAllTags
};

export const dxfCanvasViewerConfig = {
  getAllTags,
  getTagData,
  getAllExpressions,
  getExpressionData,
  tabBodyConfig,
  DynamicWidgetsProviders: {
    WidgetsProvider,
    WidgetsDataProvider,
    TabsProvider
  },
  widgetLayerConfig,
  addWidgetModalConfig
};